'use client';
import { usePromptHistoryInputHandlers } from '#pplx/frontend/apps/ask/ask-input/ask-input-core/hooks/usePromptHistoryInputHandlers.js';
import { getComputerTasksFromAPI } from '#pplx/frontend/apps/ask/queries/thread-queries/getComputerTasksFromAPI.js';
import { PROMPT_HISTORY_MAX_LENGTH } from '#pplx/frontend/composer-sdk-plugins/prompt-history/types.js';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
const COMPUTER_MAIN_HISTORY_QUERY_KEY = [
    '/rest/thread/list_computer_tasks',
    'computer-main-prompt-history',
    { limit: PROMPT_HISTORY_MAX_LENGTH },
];
export function useComputerMainPromptHistory({ value, setValue, onChange, onSubmit, trackEvent, resetKey, }) {
    const { history: promptHistory } = useComputerMainHistory();
    return usePromptHistoryInputHandlers({
        history: promptHistory,
        value,
        setValue,
        onChange,
        onSubmit,
        trackEvent,
        resetKey,
    });
}
function useComputerMainHistory() {
    const { data: threads } = useQuery({
        queryKey: COMPUTER_MAIN_HISTORY_QUERY_KEY,
        queryFn: () => getComputerTasksFromAPI({
            timeoutMs: 5000,
            reason: 'computer-main-prompt-history',
            limit: PROMPT_HISTORY_MAX_LENGTH,
        }),
    });
    return useMemo(() => ({
        history: threads
            ? threads.filter((thread) => !thread.trigger).map((thread) => thread.query_str ?? '')
            : [],
    }), [threads]);
}
//# sourceMappingURL=useComputerMainHistory.js.map